import axios from 'axios';

//FlexAuth
export const apiAuth = axios.create({
  baseURL: process.env.REACT_APP_AUTH_URL,
  timeout: 40000
});

apiAuth.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

// Flex Desk
export const apiCase = axios.create({
  baseURL: process.env.REACT_APP_CASE_URL,
  timeout: 120000
});
apiCase.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});
apiCase.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

//CRM_SERVICE
export const apiCrm = axios.create({
  baseURL: process.env.REACT_APP_CRM_URL,
  timeout: 120000
});
apiCrm.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

//FLEX_WEBHOOK
export const apiWebhook = axios.create({
  baseURL: process.env.REACT_APP_WEBHOOK_URL,
  timeout: 40000
});
apiWebhook.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

apiWebhook.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.respones && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

// Flex Portal Backend
export const apiUc = axios.create({
  baseURL: process.env.REACT_APP_FLEXUC_URL,
  timeout: 20000
});

apiUc.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

apiUc.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

//FLEX AMI
export const apiAmi = axios.create({
  baseURL: process.env.REACT_APP_AMI_URL,
  timeout: 40000
});
apiAmi.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

apiAmi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

//FlexChat
export const apiChat = axios.create({
  baseURL: process.env.REACT_APP_CHANNEL_URL,
  timeout: 40000
});
apiChat.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

apiChat.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

//Reports
export const reports = axios.create({
  baseURL: process.env.REACT_APP_REPORT_URL,
  timeout: 40000
});
reports.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

reports.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

//ReportsNode
export const reportsNode = axios.create({
  baseURL: process.env.REACT_APP_REPORT_NODE_URL,
  timeout: 60000
});
reportsNode.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

reportsNode.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);
//Export FlexChatExport
export const apiChatExport = axios.create({
  baseURL: process.env.REACT_APP_CHANNEL_DOWNLOADS,
  timeout: 2200000
});
apiChatExport.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

apiChatExport.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

//downloads PROTOCOL
export const apiProtocolDownloads = axios.create({
  baseURL: process.env.REACT_APP_CASE_URL,
  timeout: 40000
});

apiProtocolDownloads.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

apiProtocolDownloads.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

//NPS
export const apiNps = axios.create({
  baseURL: process.env.REACT_APP_SURVEY_URL,
  timeout: 40000
});

apiNps.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

apiNps.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

export const apiNpsMidia = axios.create({
  baseURL: process.env.REACT_APP_SURVEY_DOWNLOADS,
  timeout: 40000
});

apiNpsMidia.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

apiNpsMidia.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

//Configuration
export const apiConfiguration = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_URL,
  timeout: 40000
});

apiConfiguration.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

apiConfiguration.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

export const apiDownloadAudio = axios.create({
  baseURL: process.env.REACT_APP_AUDIO_URL,
  timeout: 40000
});

//Scales
export const apiScale = axios.create({
  baseURL: process.env.REACT_APP_SCALE_URL,
  timeout: 40000
});
apiScale.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

apiScale.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

//Notifications
export const apiNotifications = axios.create({
  baseURL: process.env.REACT_APP_NOTIFICATION_URL,
  timeout: 40000
});
apiNotifications.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});
apiNotifications.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

export const apiInstagramChat = axios.create({
  baseURL: process.env.REACT_APP_CHAT_INTEGRATION_URL,
  timeout: 40000
});

apiInstagramChat.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});
apiInstagramChat.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

export const apiFacebookChat = axios.create({
  baseURL: process.env.REACT_APP_CHAT_INTEGRATION_URL,
  timeout: 40000
});
apiFacebookChat.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});
apiFacebookChat.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

export const apiTelegramChat = axios.create({
  baseURL: process.env.REACT_APP_CHAT_INTEGRATION_URL,
  timeout: 40000
});
apiTelegramChat.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});
apiTelegramChat.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

// bate no mesmo endpoint do `apiInstagramChat`, o portal-chat-ts
// para garantir melhor legibilidade, estou redeclarando com o nome `apiChatTS`
export const apiChatTS = axios.create({
  baseURL: process.env.REACT_APP_CHAT_INTEGRATION_URL,
  timeout: 40000
});
apiChatTS.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});
apiChatTS.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

export const apiSMSChat = axios.create({
  baseURL: process.env.REACT_APP_CHAT_INTEGRATION_URL,
  timeout: 40000
});
apiSMSChat.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});
apiSMSChat.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

export const apiGeneric = axios.create({
  baseURL: process.env.REACT_APP_PROXY_URL,
  timeout: 40000
});
apiGeneric.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});
apiGeneric.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/user/logout';
    }
    return Promise.reject(error);
  }
);

// CRM Gas Order
export const apiCRMGasOrder = axios.create({
  baseURL: process.env.REACT_APP_CRM_NACIONAL_URL,
  timeout: 40000
});

apiCRMGasOrder.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

apiCRMGasOrder.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/activelogout';
    }
    return Promise.reject(error);
  }
);
